import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/aliBill/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/aliBill/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/aliBill/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/aliBill/delete/${id}`)
}
